import { EditorController } from '@ibiz-template/runtime';
import { ICascader } from '@ibiz/model-core';

/**
 * 级联选择器控制器
 * @return {*}
 * @author: zhujiamin
 * @Date: 2022-08-25 10:57:58
 */
export class CascaderEditorController extends EditorController<ICascader> {}
